import { ERRORS } from "@prostocheck/shared";

import {
  ERROR_CODE_NO_CONTENT,
  ERROR_CODE_OK,
  NO_CONTENT_STATUS,
  OK_STATUS,
} from "./client.constants";

/**
 * HTTP codes from ai/docs/prro-api.md. 0 is the gateway itself failing —
 * `gatewayRequest` never invents a status.
 */
export const toErrorKeyFromStatus = (status: number): string => {
  if (status === 0) return ERRORS.fiscal.gatewayUnreachable;
  if (status === 401) return ERRORS.fiscal.notAuthorised;
  if (status === 404) return ERRORS.fiscal.registerNotFound;
  if (status >= 500) return ERRORS.fiscal.serverUnavailable;
  if (status >= 400) return ERRORS.fiscal.badRequest;

  return ERRORS.common.unknown;
};

/** ErrorCode values a read-only client can actually receive. */
export const toErrorKeyFromServer = (serverCode: number): string => {
  if (serverCode === 1) return ERRORS.fiscal.registerNotFound;
  if (serverCode === 2) return ERRORS.fiscal.notAuthorised;
  if (serverCode === 11) return ERRORS.fiscal.badRequest;
  if (serverCode === 12) return ERRORS.key.signingFailed;

  return ERRORS.common.unknown;
};

export const isNoContent = ({
  status,
  serverCode,
}: {
  status: number;
  serverCode?: number;
}): boolean =>
  status === NO_CONTENT_STATUS || serverCode === ERROR_CODE_NO_CONTENT;

export const isSuccess = ({
  status,
  serverCode,
}: {
  status: number;
  serverCode?: number;
}): boolean =>
  status === OK_STATUS &&
  (serverCode === undefined || serverCode === ERROR_CODE_OK);

/**
 * The envelope wants a unique id per request; the server echoes it back and it
 * is the only way to correlate a response with what was asked.
 */
export const createRequestUid = (): string => globalThis.crypto.randomUUID();
